/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceCredential } from './ResourceCredential';

export const ListCredential: core.serialization.ObjectSchema<serializers.ListCredential.Raw, Truvity.ListCredential> =
    core.serialization.object({
        items: core.serialization.list(ResourceCredential),
    });

export declare namespace ListCredential {
    export interface Raw {
        items: ResourceCredential.Raw[];
    }
}
